module.exports = __webpack_public_path__ + "static/media/youtube.46192574.svg";